/* Accessible click-to-open navigation, including recursively nested menu levels. */
document.addEventListener('DOMContentLoaded', () => {
  const closeItem = (item) => {
    const trigger = item.querySelector(':scope > .nav-trigger');
    const submenu = item.querySelector(':scope > .nav-submenu');
    if (trigger && submenu) {
      trigger.setAttribute('aria-expanded', 'false');
      submenu.hidden = true;
      item.querySelectorAll('.nav-item.has-children').forEach(closeItem);
    }
  };

  document.querySelectorAll('.site-header .nav-trigger').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const item = trigger.closest('.nav-item');
      const submenu = item?.querySelector(':scope > .nav-submenu');
      if (!item || !submenu) return;
      const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
      const siblings = item.parentElement?.querySelectorAll(':scope > .nav-item.has-children') || [];
      siblings.forEach((sibling) => { if (sibling !== item) closeItem(sibling); });
      trigger.setAttribute('aria-expanded', String(willOpen));
      submenu.hidden = !willOpen;
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.site-header')) {
      document.querySelectorAll('.site-header .nav-item.has-children').forEach(closeItem);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.site-header .nav-item.has-children').forEach(closeItem);
    }
  });
});

document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('.mobile-toggle'),m=document.querySelector('#mobileNav');if(!b||!m)return;const setOpen=open=>{b.setAttribute('aria-expanded',String(open));m.hidden=!open;};setOpen(false);b.addEventListener('click',()=>setOpen(b.getAttribute('aria-expanded')!=='true'));});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-counter]');
    if (slides.length <= 1) return;

    let current = 0;
    let touchStartX = null;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
    };

    prev?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });

    gallery.setAttribute('tabindex', '0');

    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 45) show(current + (delta < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cart-remove]').forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.disabled) return;

      const url = button.dataset.cartChangeUrl;
      const lineKey = button.dataset.lineKey;
      if (!url || !lineKey) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: 0
          })
        });

        if (!response.ok) throw new Error('Cart update failed');

        window.location.reload();
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        console.error(error);
      }
    });
  });
});

/* Reference hero slideshows. Video slides loop continuously and remain visible. */
document.addEventListener('DOMContentLoaded', () => {
  const setupHeroSlider = (slider, selector, defaultInterval) => {
    if (!slider) return;
    const slides = Array.from(slider.querySelectorAll(selector));
    if (slides.length <= 1) return;

    let current = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (current < 0) current = 0;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        const video = slide.querySelector('video');
        if (video) {
          if (active) {
            // Restart from the beginning whenever this video slide becomes active.
            video.pause();
            try { video.currentTime = 0; } catch (error) {}
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
          } else {
            video.pause();
            try { video.currentTime = 0; } catch (error) {}
          }
        }
      });
    };

    const interval = Math.max(1000, Number(slider.dataset.interval) || defaultInterval);
    // Advance through all configured slides in order, whether each slide is an image or video.
    // Videos loop while visible, then pause when their slide is no longer active.
    window.setInterval(() => {
      show(current + 1);
    }, interval);
  };

  document.querySelectorAll('[data-reference-hero]').forEach((hero) => {
    setupHeroSlider(hero.querySelector('.reference-hero-desktop-slider'), '[data-hero-slide]', 3000);
    setupHeroSlider(hero.querySelector('[data-reference-hero-mobile]'), '[data-mobile-hero-slide]', 5000);
  });
});
